import { EyeFilled, CloudDownloadOutlined, CopyFilled, TruckOutlined } from '@ant-design/icons'
import TableBase from 'components/Table/TableBase'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import ReOrder from './ReOrder'
import { openInNewTab } from 'helpers'


const OptionAction = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;

  svg {
    cursor: pointer;
  }
`

const HistoryTable = ({
  dataList,
  setParams,
  setListSelectedOrder,
  listSelectedOrder,
  searchOrder,
}: {
  dataList: any
  setParams: (input: any) => void
  setListSelectedOrder: (input: any) => void
  listSelectedOrder: any[]
  searchOrder: () => void
}) => {

  const columns = [
    {
      title: 'Mã đơn',
      dataIndex: 'order_code',
      render: (value) => value,
      width: 180,
    },
    {
      title: 'Người nhận',
      minWidth: 180,
      render: (_, record) => (
        <div style={{ textAlign: 'left' }}>
          <p>{record?.receiver?.full_name}</p>
          <p>{record?.receiver?.phone_number}</p>
        </div>
      ),
    },
    {
      title: 'Trạng thái',
      minWidth: 180,
      render: (record) => (
        <div style={{ textAlign: 'center' }}>
          <p>{record?.status_string}</p>
          {record?.is_fail ? <p style={{ color: 'red' }}>{record?.note}</p> : ''}
        </div>
      ),
    },
    {
      title: 'Thu hộ',
      render: (record) => (
        <div style={{ textAlign: 'right' }}>
          <p>{record?.cod ? `${numberWithCommas(record?.cod)}` : 0}</p>
          <p>Ship:{numberWithCommas(record?.fee)}</p>
          <p>{record?.detail?.package?.title}</p>
        </div>
      ),
      width: 150,
    },
    {
      title: 'Thời gian',
      dataIndex: 'updated_at',
      width: 220,
      render: (_, record) => (
        <div>
          <p>Ngày tạo: {record?.created_at}</p>
          <b>Cập nhật: {record?.updated_at}</b>
        </div>
      ),
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      width: 215,
      render: (_, record) => (
        <OptionAction>
          {record?.is_fail ? (
            <ReOrder id={record?.id} searchOrder={searchOrder} />
          ) : (
            <Button onClick={() => openInNewTab(`/in-don-hang?id=${record?.id}`)} icon={<CloudDownloadOutlined />}>
              In đơn
            </Button>
          )}
          <Link to={`/tao-don-hang/${record?.id}`}>
            <Button icon={<CopyFilled />} title='Dùng lại thông tin'>
              Dùng lại thông tin
            </Button>
          </Link>
          <a href={`https://spx.vn/track?${record?.service_code}`} target={'_blank'} rel='noreferrer'>
            <Button icon={<TruckOutlined />} title='Xem lộ trình'>
              Lộ trình
            </Button>
          </a>
          <Link to={`/xem-don-hang/${record?.id}`}>
            <Button icon={<EyeFilled />}>Xem</Button>
          </Link>
        </OptionAction>
      ),
    },
  ]

  const rowSelection = {
    selectedRowKeys: listSelectedOrder.map((item) => item.id),
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setListSelectedOrder(selectedRows)
    },
  }

  const returnHtml = () => {
    return (
      <TableBase
        columns={columns}
        dataSource={dataList?.data?.orders}
        scroll={{ x: 1200 }}
        rowKey={(row) => row.id}
        pagination={{
          current: dataList?.data?.meta?.current_page,
          pageSize: dataList?.data?.meta?.per_page,
          total: dataList?.data?.meta?.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            if (pageSize !== dataList?.data?.meta?.per_page) {
              page = 1
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setParams((prev) => ({
              ...prev,
              page: page,
              per_page: pageSize,
            }))
          },
          showTotal: (total) => `Tổng ${total}`,
        }}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
      />
    )
  }
  return dataList?.data?.orders ? returnHtml() : <div style={{textAlign:'center'}}>Đang truy vấn...</div>
}

export default HistoryTable
